import React, { Component } from 'react'
import { observer } from 'mobx-react'

import CompanyTable from './companytable'

@observer(['companies', 'globals'])
export default class Leads extends Component {

  constructor(props) {
    super(props)

    if (this.props.companies.leads.length == 0) {
      this.props.companies.loadAllLeads()
    }

  }

  reload(callback) {
    this.props.companies.loadAllLeads(() => {
      if (callback != null) {
        callback()
      }
    })
  }

  render() {
    return (
      <div>
        <CompanyTable companyTypeHeading={ 'Lead' } companyStateId={ 2 } data={ this.props.companies.leads } reload={ this.reload.bind(this) } />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/companies/leads.js